<!--
//================================================================================
// ID:BC060
// ProjectName: 都営住宅募集オンライン申請
// SystemName: 都営住宅募集オンラインシステム
// JavaScriptName:BC060
//
// <<Modification History>>
// Version  | Date       | Updated By            | Content
// ---------+------------+-----------------------+--------------------------------
// 01.02.00 | 2022/11/07 | 富士通Japan株式会社    | 新規作成
// 01.03.00 | 2023/08/08 | 富士通Japan株式会社    | 令和5年度改修対応（3次リリース）
//================================================================================
-->
<template>
	<div class="contents__main">
		<error-message />
		<h2 class="contents__h2">検索条件</h2>
		<section>
			<table class="contents__table--ichiran ichiran">
				<tbody>
					<tr class="contents__input--tr">
						<th class="contents__input--title">
							募集の種類
						</th>
						<td class="contents__input--label">
							<list-box
								class="contents__input--select"
								:modelValue="form.bosyuKind"
								:name="'募集の種類'"
								:groupId="'bosyuKindInfo'"
								:cdType="'L0001'"
								:cdKbn="CD_HANDLE_TYPE.MIX_CD_HANYO1"
								:blankFlg="true"
								@update:modelValue="changeBosyuList"
								ref="bosyuKind"
								tabindex="1">
								<requestFocus />
							</list-box>
						</td>
					</tr>
					<tr>
						<th  class="contents__input--title">
							住宅の種別
						</th>
						<td class="contents__input--label">
							<list-box
								class="contents__input--select"
								:modelValue="form.jyutakuKind"
								:name="'住宅の種別'"
								:groupId="'jyutakuKindInfo'"
								:listItems="disp.jyutakuKindList"
								:cdKbn="CD_HANDLE_TYPE.CD_HANYO1"
								:blankFlg="false"
								@update:modelValue="changeJyutakuKindList"
								ref="jyutakuKind"
								tabindex="2"
							/>
						</td>
					</tr>
					<tr>
						<th class="contents__input--title">
							状況
						</th>
						<td class="contents__input--label">
							<list-box
								class="contents__input--select"
								:modelValue="form.zyokyo"
								:name="'状況'"
								:groupId="'zyokyoInfo'"
								:listItems="disp.zyokyoList"
								:cdKbn="CD_HANDLE_TYPE.ID_CD"
								:blankFlg="false"
								@update:modelValue="form.zyokyo = $event"
								ref="zyokyo"
								tabindex="3"
							/>
						</td>
					</tr>
					<tr>
						<th class="contents__input--title">
							申込者氏名
						</th>
						<td class="contents__input--label">
							氏：
							<text-input
								class="contents__input--text width-nmName"
								:modelValue="form.nmMouName1"
								:maxLength="15"
								:textType="TEXTINPUT_TYPE.FULL"
								:name="'氏'"
								:groupId="'nmName'"
								:placeholder="'（フリーワード）'"
								@update:modelValue="form.nmMouName1 = $event"
								ref="nmMouName1"
								tabindex="4" />
							名：
							<text-input
								class="contents__input--text width-nmName"
								:modelValue="form.nmMouName2"
								:maxLength="15"
								:textType="TEXTINPUT_TYPE.FULL"
								:name="'名'"
								:groupId="'nmName'"
								:placeholder="'（フリーワード）'"
								@update:modelValue="form.nmMouName2 = $event"
								ref="nmMouName2"
								tabindex="5" />
							<itemerror-message :groupId="'nmName'"/>
						</td>
					</tr>
					<tr>
						<th class="contents__input--title">
							申込者フリガナ
						</th>
						<td class="contents__input--label">
							氏：
							<text-input
								class="contents__input--text width-nmName"
								:modelValue="form.nmMouKana1"
								:maxLength="30"
								:textType="TEXTINPUT_TYPE.HALF_KANA"
								:name="'フリガナ（氏）'"
								:groupId="'huriganaInfo'"
								:placeholder="'(ﾌﾘｰﾜｰﾄﾞ)'"
								@update:modelValue="form.nmMouKana1 = $event"
								ref="nmMouKana1"
								tabindex="6" />
							名：
							<text-input
								class="contents__input--text width-nmName"
								:modelValue="form.nmMouKana2"
								:maxLength="30"
								:textType="TEXTINPUT_TYPE.HALF_KANA"
								:name="'フリガナ（名）'"
								:groupId="'huriganaInfo'"
								:placeholder="'(ﾌﾘｰﾜｰﾄﾞ)'"
								@update:modelValue="form.nmMouKana2 = $event"
								ref="nmMouKana2"
								tabindex="7" />
							<itemerror-message :groupId="'huriganaInfo'"/>
						</td>
					</tr>
					<tr>
						<th class="contents__input--title">
							電話番号
						</th>
						<td class="contents__input--label">
							<number-input
								class="contents__input--text width-idTel"
								:modelValue="form.idTel1"
								:numberType="NUMBERINPUT_TYPE.NON_PERIOD"
								:name="'電話番号（市外）'"
								:groupId="'telInfo'"
								:maxLength="5"
								@update:modelValue="form.idTel1 = $event"
								ref="idTel1"
								tabindex="8"
							/>&nbsp;-
							<number-input
								class="contents__input--text width-idTel"
								:modelValue="form.idTel2"
								:numberType="NUMBERINPUT_TYPE.NON_PERIOD"
								:name="'電話番号（市内）'"
								:groupId="'telInfo'"
								:maxLength="4"
								@update:modelValue="form.idTel2 = $event"
								ref="idTel2"
								tabindex="9"
							/>&nbsp;-
							<number-input
								class="contents__input--text width-idTel"
								:modelValue="form.idTel3"
								:numberType="NUMBERINPUT_TYPE.NON_PERIOD"
								:name="'電話番号（局番）'"
								:groupId="'telInfo'"
								:maxLength="4"
								@update:modelValue="form.idTel3 = $event"
								ref="idTel3"
								tabindex="10"
							/>
							<itemerror-message :groupId="'telInfo'"/>
						</td>
					</tr>
					<tr>
						<th class="contents__input--title margin__bottom-m25">
							申込日
						</th>
						<td class="contents__input--label">
							<div class="date">
								<date-input
									:modelValue="form.mousikomiFrom"
									:name="'申込日（自）'"
									:dateType="DATE_KIND.MOUSIKOMI_FROM"
									:groupId="'mousikomiInfo'"
									@update:modelValue="form.mousikomiFrom = $event"
									ref="mousikomiFrom"
									tabindex="11"
								/>
								<span class="date-to">～</span>
								<date-input
									:modelValue="form.mousikomiTo"
									:name="'申込日（至）'"
									:dateType="DATE_KIND.MOUSIKOMI_TO"
									:groupId="'mousikomiInfo'"
									@update:modelValue="form.mousikomiTo = $event"
									ref="mousikomiTo"
									tabindex="14"
								/>
							</div>
							<itemerror-message :groupId="'mousikomiInfo'" />
						</td>
					</tr>
					<tr class="contents__input--tr">
						<th class="contents__input--title bosyu-title">公募年月</th>
						<td class="padding__bottom-10">
							<year-month-input
								:modelValue="form.ymBosyu"
								:name="'公募年月'"
								:groupId="'ymBosyuInfo'"
								:listItems="disp.ymBosyuList"
								:dateType="YEAR_MONTH_KIND.KOBO_MOUSIKOMI"
								@update:modelValue="form.ymBosyu = $event"
								ref="ymBosyu"
								tabindex="17"
							/>
							<itemerror-message :groupId="'ymBosyuInfo'" />
						</td>
					</tr>
					<tr>
						<th class="contents__input--title uketuke-title">受付番号</th>
						<td class="padding__bottom-10">
							<number-input
								class="width-uketukeNo"
								:modelValue="form.noUketuke"
								:maxLength="5"
								:name="'受付番号'"
								:groupId="'uketukeNoInfo'"
								:numberType="NUMBERINPUT_TYPE.INTEGER"
								@update:modelValue="form.noUketuke = $event"
								ref="noUketuke"
								tabindex="19"
							/>
							<itemerror-message :groupId="'uketukeNoInfo'" />
						</td>
					</tr>
					<tr class="contents__input--tr">
						<th class="contents__input--title">
							入力したID
						</th>
						<td class="contents__input--label">
							<list-box
								class="contents__input--select width-auto"
								:modelValue="form.inputId"
								:name="'入力したID'"
								:listItems="disp.inputIdList"
								:blankFlg="false"
								:groupId="'inputId'"
								@update:modelValue="form.inputId = $event"
								ref="inputIdList"
								tabindex="21"
							/>
						</td>
					</tr>
					<tr class="contents__input--tr">
						<th class="contents__input--title">受付方法</th>
						<td class="margin__top-m20">
							<div class="width-uketukehou">
								<check-box
									:modelValue="form.uketukeho"
									:listItems="disp.uketukehouList"
									:name="'受付方法'"
									@update:modelValue="form.uketukeho = $event"
									ref="uketukehou"
									tabindex="22"
								/>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
			<div class="contents__div--center">
				<input type="button" value="検索" class="contents__btn--normal" @click="clickSearchBtn" tabindex="22" />
			</div>
			<hr>
		</section>
		<div v-if="disp.hyojiMeisaiList.length != 0">
			<pagination
					:name="'ページヘッダー'"
					:headerTitle="'申込み履歴一覧'"
					:class="'margin__bottom-3'"
					:listCount="disp.shutokuMeisaiList.length"
					:displaySortFlg="false"
					:tabindex="23"
					:clickPageSwitch="clickPageSwitchBtn"
					ref="pageHeader" />
			<div align="center">
				<table border="1" id="list" class="contents__table--itiran">
					<thead>
						<tr id="listheader">
							<th id="meisaititle1">申込日</th>
							<th id="meisaititle2"><div id="meisai-margin">利用者氏名</div><div id="meisai-margin">フリガナ</div><div>ID</div></th>
							<th id="meisaititle3"><div id="meisai-margin">申込者氏名</div><div>フリガナ</div></th>
							<th id="meisaititle4"><div id="meisai-margin">公募年月</div><div>募集の種類</div></th>
							<th id="meisaititle5"><div id="meisai-margin">受付</div><div>番号</div></th>
							<th id="meisaititle6"><div id="meisai-margin">申込</div><div>地区番号</div></th>
							<th id="meisaititle7">住宅名</th>
							<th id="meisaititle8">状況</th>
						</tr>
					</thead>
					<tbody>
						<tr id="meisaienen" v-on:click="clickMeisai(row)"  v-for="row in disp.hyojiMeisaiList" :key="row.noRenzoku">
							<td id="meisai_padding-center">{{ co_editDate(row.dtMosikomi) }}</td>
							<td id="meisai_padding-left" class="width-meisai2">
								<div id="meisai-margin">{{ row.nmName }}</div>
								<div id="meisai-margin">{{ row.nmKana }}</div>
								<div style="font-size: 12px;">{{ row.idMailaddress }}</div>
							</td>
							<td id="meisai_padding-left">
								<div id="meisai-margin">{{ row.nmMouname }}</div>
								<div>{{ row.nmMoukana1 }}&nbsp;{{ row.nmMoukana2 }}</div>
							</td>
							<td id="meisai_padding-left"><div id="meisai-margin">{{ co_editDateNengetsu(row.ymBosyu) }}</div><div>{{ row.nmBosyu }}</div></td>
							<td id="meisai_padding-center">{{ row.noUketuke }}</td>
							<td id="meisai_padding-center">{{ row.noMouchiku }}</td>
							<td id="meisai_padding-left">{{ row.jyutakuName }}</td>
							<td id="meisai_padding-center">{{ row.nmCd }}</td>
						</tr>
					</tbody>
				</table>
			</div>
			<pagination
				:name="'ページフッター'"
				:class="'margin__top-10'"
				:listCount="disp.shutokuMeisaiList.length"
				:displaySortFlg="false"
				:displayFotterFlg="true"
				:tabindex="32"
				:clickPageSwitch="clickPageSwitchBtn"
				ref="pageFotter" />
			<br />
			<br />
		</div>
	</div>
</template>

<script>
import ErrorMessage from '@/components/ErrorMessage.vue';
import TextInput from '@/components/TextInput.vue';
import NumberInput from '@/components/NumberInput.vue';
import Pagination from '@/components/Pagination.vue';
import ListBox from '@/components/ListBox.vue';
import CheckBox from "@/components/CheckBox.vue";
import ItemErrorMessage from '@/components/ItemErrorMessage.vue';
import YearMonthInput from '@/components/YearMonthInput.vue';
import DateInput from '@/components/DateInput.vue';

import { co_post } from '@/common/ajaxUtility.js';
import { co_getMessage } from '@/common/messageUtility.js';
import { co_isEmpty } from '@/common/checkUtility.js';
import { co_editDate, co_editDateNengetsu } from '@/common/stringUtility.js';
import { co_toTop, co_toTrans } from '@/common/screenUtility.js';

import { NUMBERINPUT_TYPE, TEXTINPUT_TYPE, CD_HANDLE_TYPE, YEAR_MONTH_KIND, DATE_KIND } from '@/const/const.js';
import { STORE_VIEW_PROGRESS, STORE_ERROR_CLEAR, STORE_DATA_ADD_DATA, STORE_DATA_GETDATA,
			STORE_ERROR_SETMSG, STORE_ERROR_IS_ERRFLG, STORE_ERROR_SET_INPUT_ERR, STORE_VIEW_CLEAR_PAGE } from '@/const/store.js';
import { PATH_BC060_INIT, PATH_BC060_SEARCH, API_LIST_ITEMS } from '@/const/route.js';

export default {
	name: "BC060",
	components: {
		'error-message': ErrorMessage,
		'text-input': TextInput,
		'number-input': NumberInput,
		'pagination': Pagination,
		'list-box': ListBox,
		'check-box': CheckBox,
		'itemerror-message': ItemErrorMessage,
		'year-month-input': YearMonthInput,
		'date-input': DateInput,
	},
	props: {
		groupId: {type: String, default: ''},					// 項目グループID
	},
	data: function () {
		return {
			
			form: {
				bosyuKind: '254',		// 募集の種類
				jyutakuKind: '', 		// 住宅の種別
				zyokyo: '', 			// 状況
				nmMouName1: '',			// 申込者氏名（氏）
				nmMouName2: '',			// 申込者氏名（名）
				nmMouName: '',			// 申込者氏名
				nmMouKana1: '',			// フリガナ（氏）
				nmMouKana2: '',			// フリガナ（名）
				idTel1: '',				// 電話番号（市外）
				idTel2: '',				// 電話番号（市内）
				idTel3: '',				// 電話番号（局番）
				mousikomiFrom: '', 		// 申込日(From)
				mousikomiTo: '', 		// 申込日(To)
				ymBosyu: '', 			// 公募年月
				noUketuke: '', 			// 受付番号
				inputId: '',			// 入力したID
				uketukeho: '',			// 受付方法
			},
			disp: {
				kbBosyuHanyo1: '',			// 募集の種類リストの汎用コード1
				jyutakuKindList: [],		// 住宅の種別リスト
				zyokyoList: [],				// 状況リスト
				uketukehouList: [],			// 受付方法リスト
				inputIdDataList: [],		// 利用者マスタデータリスト
				inputIdList: [],			// 入力したIDリスト
				hyojiMeisaiList:[],			// 申込者一覧リスト(表示用）
				shutokuMeisaiList:[],		// 取得した申込者一覧リスト
				dataFlg: false,				// データフラグ
				jyutakuKindBack: ''			// 住宅の種別（退避用）
			},
			co_editDate: co_editDate,
			co_editDateNengetsu: co_editDateNengetsu,
			NUMBERINPUT_TYPE: NUMBERINPUT_TYPE,
			TEXTINPUT_TYPE: TEXTINPUT_TYPE,
			CD_HANDLE_TYPE: CD_HANDLE_TYPE,
			YEAR_MONTH_KIND: YEAR_MONTH_KIND,
			DATE_KIND: DATE_KIND,
		};
	},
	mounted: async function () {
		await this.$nextTick();

		// フォーカス設定
		this.$refs.bosyuKind.focus();
	},
	created: async function() {

		// エラーをクリア
		this.$store.commit(STORE_ERROR_CLEAR);

		// ローディング表示開始
		this.$store.commit(STORE_VIEW_PROGRESS, true);

		//入力したID初期情報取得
		let initData = await co_post(PATH_BC060_INIT);
		this.disp.inputIdDataList = initData.inputIdList;

		// 前回の検索条件確認
		let data = this.$store.getters[STORE_DATA_GETDATA]('BC060');
		if (data != null) {

			// 前回情報を画面に設定
			this.form = data;
			this.disp.jyutakuKindBack = data.jyutakuKind;

			// 申込者一覧情報取得
			let list = await co_post(PATH_BC060_SEARCH, this.form);

			// 取得件数が０件の場合
			if (list.mousikomishaListBC060.length == null || list.mousikomishaListBC060.length == 0 ) {

				// エラーメッセージ：E0049を表示
				this.$store.commit(STORE_ERROR_SETMSG, co_getMessage('E0049'));

				// ローディング表示終了
				this.$store.commit(STORE_VIEW_PROGRESS, false);
				return;

			}

			// 申込者一覧情報を一覧に設定
			this.disp.hyojiMeisaiList = list.mousikomishaListBC060;
			this.disp.shutokuMeisaiList = this.disp.hyojiMeisaiList;

			this.disp.dataFlg = true;
		} 

		// 募集の種類初期値による住宅の種別リスト、申込日（自）、公募年月の取得
		this.changeBosyuList(this.form.bosyuKind);

		// 前回の検索条件（住宅の種別）
		if (this.disp.jyutakuKindBack != '') {
			this.form.jyutakuKind = this.disp.jyutakuKindBack;
		}

		// 入力したID初期値設定
		let inputIdList = new Array();
		let listId = this.disp.inputIdDataList;
		inputIdList.push({idCd : '', nmCd : '----'});
		for (let i = 0; i < listId.length; i++) {
			inputIdList.push({ idCd: listId[i].loginMail, nmCd: listId[i].riyoshaName });
		}
		this.disp.inputIdList = inputIdList;

		// 受付方法項目設定
		this.disp.uketukehouList = [
			{ idCd: '1', nmCd: '電話受付分'},
			{ idCd: '0', nmCd: 'オンライン受付分'}
		];

		// ローディング表示終了
		this.$store.commit(STORE_VIEW_PROGRESS, false);

	},
	methods: {

		// 募集の種類リスト変更
		changeBosyuList: async function (val) {
			this.form.bosyuKind = val;

			this.disp.kbBosyuHanyo1 = '';
			this.disp.jyutakuKindList = new Array();
			this.disp.zyokyoList = new Array();
			this.form.jyutakuKind = '';

			// 選択された募集の種類リストの汎用コード１を取得
			this.disp.kbBosyuHanyo1 = this.form.bosyuKind.substring(2);

			// 住宅の種別リスト作成
			if (this.form.bosyuKind.substring(2) != '') {
				let resultList = [];
				resultList.push({cdHanyo1 : '', nmCd : '----'});
				let params = { cdType: 'L0002', cdHanyo1: '', cdHanyo2: this.disp.kbBosyuHanyo1, cdHanyo3: '' };
				let list = await co_post( API_LIST_ITEMS, params );
				if ( list != null ) {
					for ( let i = 0; i < list.length; i++ ) {
						// リストを追加
						resultList.push( {cdHanyo1: list[i].cdHanyo1 + list[i].cdHanyo3, nmCd: list[i].nmCd} );
					}
				}
				this.disp.jyutakuKindList = resultList;
			} else {
				this.disp.jyutakuKindList.push({cdHanyo1 : '', nmCd : '----'});
			}

			// 状況初期値設定
			let resultZyokyoList = [];
			resultZyokyoList.push({idCd : '', nmCd : '----'});
			// 募集の種類が「毎月募集」または「定期募集（抽せん方式）」の場合
			if (this.form.bosyuKind.substring(2) == '1' || this.form.bosyuKind.substring(2) == '2') {
				let params = { cdType: 'L0102', cdHanyo1: '', cdHanyo2: '', cdHanyo3: '' };
				let list = await co_post( API_LIST_ITEMS, params );
				if ( list != null ) {
					for ( let i = 0; i < list.length; i++ ) {
						// リストを追加
						resultZyokyoList.push( {idCd: list[i].idCd, nmCd: list[i].nmCd} );
					}
				}
				this.disp.zyokyoList = resultZyokyoList;

			// 募集の種類が「定期募集（ポイント方式）」の場合
			} else if (this.form.bosyuKind.substring(2) == '3') {
				
				let paramsL0102 = { cdType: 'L0102', cdHanyo1: '', cdHanyo2: '', cdHanyo3: '' };
				let listL0102 = await co_post( API_LIST_ITEMS, paramsL0102 );
				if ( listL0102 != null ) {
					for ( let i = 0; i < listL0102.length; i++ ) {
						// リストを追加
						resultZyokyoList.push( {idCd: listL0102[i].idCd, nmCd: listL0102[i].nmCd} );
					}
				}

				let paramsL0103 = { cdType: 'L0103', cdHanyo1: '', cdHanyo2: '', cdHanyo3: '' };
				let listL0103 = await co_post( API_LIST_ITEMS, paramsL0103 );
				if ( listL0103 != null ) {
					for ( let i = 0; i < listL0103.length; i++ ) {
						let count = resultZyokyoList.filter(x => x.idCd == listL0103[i].idCd).length;
						if (count == 0) {
							// リストを追加
							resultZyokyoList.push( {idCd: listL0103[i].idCd, nmCd: listL0103[i].nmCd} );
						}
					}
				}
				this.disp.zyokyoList = resultZyokyoList;

			// 募集の種類が「随時募集」の場合
			} else if (this.form.bosyuKind.substring(2) == '4') {
				let params = { cdType: 'L0104', cdHanyo1: '', cdHanyo2: '', cdHanyo3: '' };
				let list = await co_post( API_LIST_ITEMS, params );
				if ( list != null ) {
					for ( let i = 0; i < list.length; i++ ) {
						// リストを追加
						resultZyokyoList.push( {idCd: list[i].idCd, nmCd: list[i].nmCd} );
					}
				}
				this.disp.zyokyoList = resultZyokyoList;

			// 募集の種類が「空白」の場合
			} else if (this.form.bosyuKind.substring(2) == '') {
				this.disp.zyokyoList.push({idCd : '', nmCd : '----'});
			}

			// 募集の種類の変更に伴い、選択中の状況が存在しない場合、先頭行を選択
			let isZyokyoExist = false;
			for ( let i = 0; i < this.disp.zyokyoList.length; i++ ) {
				if (this.disp.zyokyoList[i].idCd == this.form.zyokyo) {
					isZyokyoExist = true;
				}
			}
			if (!isZyokyoExist) {
				this.form.zyokyo = '';
			}

			// 前回情報が存在しない場合
			if (this.disp.dataFlg === false) {
				// 随時募集の場合
				if (this.form.bosyuKind.substring(2) == '4'){
					// 申込日（自）初期値設定
					let today = new Date();
					let sysDate = today.getFullYear() + ("00" + (today.getMonth() + 1)).slice(-2) + ("00" + today.getDate()).slice(-2);
					this.form.mousikomiFrom = String(sysDate);
					this.form.mousikomiTo = "";

					// 公募年月初期値設定
					let currentYear = new Date();
					if(currentYear.getMonth() + 1 >= 1 && currentYear.getMonth() + 1 <=3){
						this.form.ymBosyu = String(currentYear.getFullYear() -1) + "04";
					}else{
						this.form.ymBosyu = String(currentYear.getFullYear()) + "04";
					}
				} else {
					this.form.ymBosyu = "";
					this.form.mousikomiFrom = "";
					this.form.mousikomiTo = "";
				}
			} else {
				this.disp.dataFlg = false;
			}

			//日付入力時保持
			await this.$nextTick();
			this.$refs.ymBosyu.setValue(this.form.ymBosyu);
			this.$refs.mousikomiFrom.setValue(this.form.mousikomiFrom);
			this.$refs.mousikomiTo.setValue(this.form.mousikomiTo);

		},

		// 住宅の種別リスト変更
		changeJyutakuKindList: async function (val) {
			this.form.jyutakuKind = val;

			// 選択された住宅の種別リストの汎用コード３を取得
			let bosyuHoshiki = '';
			if (this.form.jyutakuKind != '') {
				bosyuHoshiki = this.form.jyutakuKind.substring(2);
			} else {
				// 未選択の場合、状況リスト再取得無し
				if (this.form.bosyuKind.substring(2) != '3') {
					return;
				}
			}

			// 状況初期値設定
			this.disp.zyokyoList = new Array();
			let resultZyokyoList = [];
			resultZyokyoList.push({idCd : '', nmCd : '----'});
			// 募集方式が「毎月募集」または「定期募集（抽せん方式）」の場合
			if (bosyuHoshiki == '1' || bosyuHoshiki == '2') {
				let params = { cdType: 'L0102', cdHanyo1: '', cdHanyo2: '', cdHanyo3: '' };
				let list = await co_post( API_LIST_ITEMS, params );
				if ( list != null ) {
					for ( let i = 0; i < list.length; i++ ) {
						// リストを追加
						resultZyokyoList.push( {idCd: list[i].idCd, nmCd: list[i].nmCd} );
					}
				}
				this.disp.zyokyoList = resultZyokyoList;

			// 募集方式が「定期募集（ポイント方式）」の場合
			} else if (bosyuHoshiki == '3' || this.form.bosyuKind.substring(2) == '3') {
				if (this.form.jyutakuKind != '') {
					let params = { cdType: 'L0103', cdHanyo1: '', cdHanyo2: '', cdHanyo3: '' };
					let list = await co_post( API_LIST_ITEMS, params );
					if ( list != null ) {
						for ( let i = 0; i < list.length; i++ ) {
							// リストを追加
							resultZyokyoList.push( {idCd: list[i].idCd, nmCd: list[i].nmCd} );
						}
					}
				} else {
					let paramsL0102 = { cdType: 'L0102', cdHanyo1: '', cdHanyo2: '', cdHanyo3: '' };
					let listL0102 = await co_post( API_LIST_ITEMS, paramsL0102 );
					if ( listL0102 != null ) {
						for ( let i = 0; i < listL0102.length; i++ ) {
							// リストを追加
							resultZyokyoList.push( {idCd: listL0102[i].idCd, nmCd: listL0102[i].nmCd} );
						}
					}

					let paramsL0103 = { cdType: 'L0103', cdHanyo1: '', cdHanyo2: '', cdHanyo3: '' };
					let listL0103 = await co_post( API_LIST_ITEMS, paramsL0103 );
					if ( listL0103 != null ) {
						for ( let i = 0; i < listL0103.length; i++ ) {
							let count = resultZyokyoList.filter(x => x.idCd == listL0103[i].idCd).length;
							if (count == 0) {
								// リストを追加
								resultZyokyoList.push( {idCd: listL0103[i].idCd, nmCd: listL0103[i].nmCd} );
							}
						}
					}
				}
				
				this.disp.zyokyoList = resultZyokyoList;

			// 募集方式が「随時募集」の場合
			} else if (bosyuHoshiki == '4') {
				let params = { cdType: 'L0104', cdHanyo1: '', cdHanyo2: '', cdHanyo3: '' };
				let list = await co_post( API_LIST_ITEMS, params );
				if ( list != null ) {
					for ( let i = 0; i < list.length; i++ ) {
						// リストを追加
						resultZyokyoList.push( {idCd: list[i].idCd, nmCd: list[i].nmCd} );
					}
				}
				this.disp.zyokyoList = resultZyokyoList;

			// 住宅の種別が「空白」の場合
			} else {
				this.disp.zyokyoList.push({idCd : '', nmCd : '----'});
			}

			// 住宅の種別の変更に伴い、選択中の状況が存在しない場合、先頭行を選択
			let isZyokyoExist = false;
			for ( let i = 0; i < this.disp.zyokyoList.length; i++ ) {
				if (this.disp.zyokyoList[i].idCd == this.form.zyokyo) {
					isZyokyoExist = true;
				}
			}
			if (!isZyokyoExist) {
				this.form.zyokyo = '';
			}
		},

		// 検索ボタン押下
		clickSearchBtn: async function() {

			// エラーをクリア
			this.$store.commit(STORE_ERROR_CLEAR);

			// 単項目チェック
			this.$refs.nmMouName1.validate();
			this.$refs.nmMouName2.validate();
			this.$refs.nmMouKana1.validate();
			this.$refs.nmMouKana2.validate();
			this.$refs.idTel1.validate();
			this.$refs.idTel2.validate();
			this.$refs.idTel3.validate();
			this.$refs.mousikomiFrom.validate();
			this.$refs.mousikomiTo.validate();
			this.$refs.ymBosyu.validate();
			this.$refs.noUketuke.validate();

			// 入力チェックエラーが存在する場合
			if (this.$store.getters[STORE_ERROR_IS_ERRFLG]) {
				return;
			}

			let inputError = false;

			//申込日チェック
			if (!co_isEmpty(this.form.mousikomiFrom) && !co_isEmpty(this.form.mousikomiTo)) {
				if (this.form.mousikomiFrom > this.form.mousikomiTo) {
					// エラーメッセージ：E0099を表示
					this.$store.commit(STORE_ERROR_SET_INPUT_ERR, {
						id: "mousikomiInfo",
						msg: co_getMessage("E0099"),
					});
					this.$refs.mousikomiFrom.setError();
					this.$refs.mousikomiTo.setError();
					if (!inputError) this.$refs.mousikomiFrom.focus();
					inputError = true;
				}
			}

			// 入力チェックエラーが存在しない場合
			if (!this.$store.getters[STORE_ERROR_IS_ERRFLG]) {
				// 検索処理実行
				this.doSearch();
			}

		},
		// 検索実行
		doSearch: async function () {

			// ローディング表示開始
			this.$store.commit(STORE_VIEW_PROGRESS, true);

			// 明細を初期化
			this.disp.hyojiMeisaiList = [];
			this.$store.commit(STORE_VIEW_CLEAR_PAGE);

			// 申込者一覧情報取得
			let data = await co_post(PATH_BC060_SEARCH, this.form);

			// 取得件数が０件の場合
			if (data.mousikomishaListBC060.length == null || data.mousikomishaListBC060.length == 0) {
				// エラーメッセージ：E0049を表示
				this.$store.commit(STORE_ERROR_SETMSG, co_getMessage('E0049'));

				// ローディング表示終了
				this.$store.commit(STORE_VIEW_PROGRESS, false);
				return;

			}

			// 申込者一覧情報を一覧に設定
			this.disp.hyojiMeisaiList = data.mousikomishaListBC060;
			this.disp.shutokuMeisaiList = this.disp.hyojiMeisaiList;

			// 入力値保持
			this.$store.commit(STORE_DATA_ADD_DATA, { id:'BC060', data: this.form });

			// ローディング表示終了
			this.$store.commit(STORE_VIEW_PROGRESS, false);
		},
		// 明細押下
		clickMeisai: function (row) {

			// 申込者情報詳細（管理者用）画面に遷移
			let params = {
							dtMosikomi : row.dtMosikomi,
							ymBosyu : row.ymBosyu,
							noRenzoku : row.noRenzoku
						};
			co_toTrans('BC061', params);
		},
		// ページ切替ボタン押下処理
		clickPageSwitchBtn: function (startIndex, endIndex) {

			let eitMeisaiList = [];
			for (let i = startIndex; i < endIndex; i++) {
				eitMeisaiList.push(this.disp.shutokuMeisaiList[i]);
			}
			this.disp.hyojiMeisaiList = eitMeisaiList;

			// ページトップへ遷移
			co_toTop();
		}
	}
};
</script>

<style scoped>

@media all and (-ms-high-contrast: none) {
	.ichiran th:nth-child(1) {
		width: 8% !important;
	}
	.ichiran td:nth-child(2) {
	width: 41% !important;
	}

	.ichiran th:nth-child(3) {
		width: 8% !important;
	}

	.ichiran td:nth-child(4) {
		width: 41% !important;
	}
}

.contents__main{
	margin-left: 1% !important;
	margin-right: 1% !important;
}
.contents__table--ichiran{
	width: 100%;
	table-layout: fixed;
}
.contents__table--ichiran th,
.contents__table--ichiran td {
	line-height: 2em;
	vertical-align: top;
	padding: 10px 10px 10px;
	position: relative; 
}
/* 受付番号 */
.uketuke-title {
	background-color: #fdfdfd;
}
/* 申込日（自） 申込日（至） */
.date {
display: flex
}
.date-to{
margin: 0 10px 0 10px
}
.width-uketukeNo {
	font-size: 16px;
	background: #fffffa;
	border: 1px solid #666666;
	border-radius: 3px;
	color: #262626;
	padding: 5px 5px;
	font-family: sans-serif;
	width: 10%;
	text-align: right;
	margin-right: 7px;
}

.width-uketukehou {
	margin-left: -15px;
}

.ichiran th:nth-child(1) {
	width: 7%;
}

.ichiran td:nth-child(2) {
	width: 42%;
}

.ichiran th:nth-child(3) {
	width: 7%;
}

.ichiran td:nth-child(4) {
	width: 42%;
}
.width-nmName {
	width: 36%;
}
.width-idTel {
	width: 9%;
	text-align: left;
}
.width-meisai2 {
	max-width: 176px;
	word-wrap: break-word;
}
#meisaititle1{
	width: 14%;
	padding-top: 28px;
	padding-bottom: 28px;
}
#meisaititle2{
	width: 17%;
}
#meisaititle3{
	width: 17%;
}
#meisaititle4{
	width: 14%;
}
#meisaititle5{
	width: 6%;
}
#meisaititle6{
	width: 8%;
}
#meisaititle7{
	width: 16%;
}
#meisaititle8{
	width: 8%;
}
#list{
	width: 100%;
}
#list tbody tr:nth-child(even) td, #list tbody tr:nth-child(even) th {
	background-color: #eeeeee;
}
#list tbody tr:hover td, #list tbody tr:hover th {
	background-color: #fff5d5;
}
#meisai_padding-left{
	padding-top: 15px;
	padding-bottom: 14px;
	text-align: left;
}
#meisai_padding-center{
	text-align: center;
}
#meisai-margin{
	margin-bottom: 5px;
}
</style>
